import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from "formik";
import { ControlLabel } from "react-bootstrap";
import FormikFormControl from './FormikFormControl'

class FormikTextAreaControl extends Component {
  static propTypes = {
    fieldLabel: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    errors: PropTypes.any.isRequired,
    touched: PropTypes.any.isRequired
  }

  render () {
    const { fieldName, fieldLabel, textareaHeight } = this.props
    return (
      <FormikFormControl {...this.props}>
        <ControlLabel>{fieldLabel}</ControlLabel>
        <Field component='textarea' name={fieldName} className="form-control input-sm" style={{height:textareaHeight || 60}} />
      </FormikFormControl>)
  }
}

export default FormikTextAreaControl